import styled from 'styled-components';

export const CanvasContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

export const SignatureLabel = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
  text-align: center;
`;

export const Instructions = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0 0 20px 0;
  text-align: center;
`;

export const CanvasWrapper = styled.div`
  border: 2px solid #3498db;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;

  /* Touch optimization */
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
`;

export const Canvas = styled.canvas`
  display: block;
  width: 100%;
  cursor: crosshair;
  background: #ffffff;

  /* Prevent text selection during drawing */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Smooth touch drawing */
  touch-action: none;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
`;

export const ClearButton = styled.button`
  padding: 12px 24px;
  background: #e74c3c;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #c0392b;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: #bdc3c7;
    cursor: not-allowed;
    opacity: 0.6;
  }

  /* Mobile optimization */
  @media (max-width: 768px) {
    padding: 14px 28px;
    font-size: 16px;
    min-height: 48px; /* Minimum touch target size */
  }
`;
